import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  Body,
  Data,
  ExtendedBox,
  ExtendedFlex,
  Tooltip,
  TooltipIcon,
} from '../../coreui';

const SummaryItem = ({ value, label, dataType, valueFormat, tooltipText }) => {
  const formattedValue = numeral(value).format(valueFormat);
  const width = (dataType === 'D8') ? ['100%', '450px', '540px', '600px'] : ['100%', '210px', '300px', '390px'];
  return (
    <ExtendedBox
      py={10}
      mx={['0px', '2em']}
      width={width}
    >
      <ExtendedBox>
        <Data type={dataType}>{formattedValue}</Data>
      </ExtendedBox>
      <ExtendedFlex
        borderTop="1px solid #A7A9AC"
        alignItems="center"
      >
        <Data
          type="D3"
          color="#A7A9AC"
        >{label}</Data>
        {
          tooltipText &&
          <ExtendedFlex>
            <TooltipIcon ml={5} tooltipId={label} />
            <Tooltip id={label} ml={5}>
              <Body type="B5">
                {tooltipText}
              </Body>
            </Tooltip>
          </ExtendedFlex>
        }
      </ExtendedFlex>
    </ExtendedBox>
  );
};

SummaryItem.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  dataType: PropTypes.string,
  valueFormat: PropTypes.string,
  tooltipText: PropTypes.string,
};

export default SummaryItem;
